module.exports = __webpack_public_path__ + "img/dp-jy-qt4.828ab578.png";